/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/settings/app.settings.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppSettingsService} from '../../services/app.app_settings.service';
import {AppNavbarService} from '../../services/app.navbar.service';
import {Setting} from '../../models/setting';
import {AppMessageService} from '../../services/app.message.service';
import {AppPageloaderService} from '../../services/app.pageloader.service';
import {AppPageTitleService} from '../../services/app.page-title.service';
import {firstValueFrom, Observable} from 'rxjs';
import {SettingsBoxInterface} from '../../interfaces/settings-box-interface';
import {CanComponentDeactivate} from '../../interfaces/can-deactivate.interface';
import {AppDialogsService} from '../../services/app.dialogs.service';

/**
 * Zweck: Beschreibt class AppSettingsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
  selector: 'app-settings',
  templateUrl: 'app.settings.component.html',
  styleUrls: ['app.settings.component.scss'],
  standalone: false
})
export class AppSettingsComponent implements OnInit, OnDestroy, SettingsBoxInterface, CanComponentDeactivate {
  static id = 'AppSettingsComponent';
  settings: Setting[];

  value: any;

  loadReady = false;

  saveReady = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppSettingsService, private nbsvc: AppNavbarService, private msg: AppMessageService,
              private loader: AppPageloaderService, private tsvc: AppPageTitleService, private dsvc: AppDialogsService) {
  }

/**
 * Beschreibt Methode canDeactivate und ihren Rückgabevertrag.
 */
  async canDeactivate(): Promise<any> {
    if (!this.saveReady) { return true; }

    const obs = new Observable((obs) => {
      this.dsvc.confirm('warning', 'Ungespeicherte Änderungen!', 'Diese gehen bei Verlassen verloren. Wirklich verlassen?', () => {
        obs.next(true);
      }, () => {
        obs.next(false);
      });
    });

    return await firstValueFrom(obs);
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this.nbsvc.clear();
    this.tsvc.resetTitle();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.nbsvc.setLabel('Einstellungen');
    this.tsvc.setTitle('Einstellungen');
    this.load();
  }

/**
 * Beschreibt Methode onClick und ihren Rückgabevertrag.
 */
  onClick(id) {
    this.svc.clickUserSetting(id).subscribe(s => {
      if (s) {
        this.msg.info(s);
      } else {
        this.msg.error(s);
      }
    });
  }

/**
 * Beschreibt Methode onTest und ihren Rückgabevertrag.
 */
  onTest(id, val): Observable<boolean> {
    return new Observable<boolean>(obs => {
      this.svc.testUserSettings(id, val).subscribe(s => {
        obs.next(s);
        obs.complete();
      });
    });
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.svc.getUserSettings().subscribe(s => {
      this.settings = s;
    });
  }

/**
 * Beschreibt Methode save und ihren Rückgabevertrag.
 */
  save() {
    this.saveReady = false;

    const l = this.loader.start();

    this.svc.setUserSettings(this.value).subscribe({
      next: (s) => {
        if (s) {
          this.msg.info('Gespeichert!');
        } else {
          this.msg.info('Fehler!');
        }
        l.stop();

      }, error: () => {
        this.saveReady = true;
        l.stop();
      }
    });
  }
}
